/**
 * Component: Image Slider
 */

var dnDepartments = dnDepartments || {};

dnDepartments.imageSlider = dnDepartments.imageSlider || function () {
	this.init = function () {
		setupOwl();
		//zoom();
	};

	this.setupOwl = function () {
		$.each($('.nc-grid-imageslider__inner'), function(){
			var owl = $(this);
			var $next = owl.next('.nc-grid-imageslider__nav').find(".js-owl-next");
			var $prev  = owl.next('.nc-grid-imageslider__nav').find(".js-owl-prev");

			if(owl.length){

				owl.owlCarousel({
				   	onResized :  novicell.responsiveLazyloadImage.onResize(),
					itemElement: "figure",
					items:1,
					lazyLoad:true,
					loop:false,
					nav:false,
					dots: false,
					navText: ["forrige","næste"],

					// Disable arrow first or last slide
					onTranslated: function(i){
						if(i.item.index == 0){
							$prev.addClass('disabled');
						} else {
							$prev.removeClass('disabled');
						}

						if(i.item.index == i.item.count - 1){
							$next.addClass('disabled');
						} else {
							$next.removeClass('disabled');
						}
					}
				});

				// Set custom next/prev click events for "logged in slider"
				$next.click(function(e){
				        e.preventDefault();
				        owl.trigger('next.owl.carousel');
				})
				$prev.click(function(e){
				        e.preventDefault();
				        owl.trigger('prev.owl.carousel');
				})
			}
		});
	}

	// Not used for now
	/*this.zoom = function () {
		// js-imageslider-zoom
		$('#js-imageslider-zoom').on('click', function () {
			var image = $('.nc-grid-imageslider__inner .owl-item.active img')[0].getAttribute('data-img-src');

			var html = '<div style="position:fixed;top:5px;left:5px;right:5px;bottom:5px;background:red;">' +
				'<img src="' + image + '" alt=""/>' +
				'</div>';

			$(this).
		});
	}*/

	return {
		init: init
	}
}();